import { routes } from '@fsd/shared/config/routes/routesConfig';
import { FileBarChart, Lock, PackageCheck, User, Wrench } from 'lucide-react';

export const accountMenuItems = [
  {
    title: 'Пользователь',
    icon: <User />,
    items: [
      {
        to: routes.account.path,
        label: routes.account.title,
      },
      // {
      //   to: '/settings/notices/',
      //   label: 'Уведомления',
      // },
    ],
  },
  {
    title: 'Настройки Организаций',
    icon: <Wrench />,
    items: [
      {
        to: routes.organisations.path,
        label: routes.organisations.title,
        section: routes.organisations.section,
      },
    ],
  },

  {
    title: 'Финансы и Управление',
    icon: <FileBarChart />,
    items: [
      {
        to: routes.articleManagement.path,
        label: routes.articleManagement.title,
        section: routes.articleManagement.section,
      },
      {
        to: routes.closingPeriods.path,
        label: routes.closingPeriods.title,
      },
    ],
  },
  {
    title: 'Безопасность',
    icon: <Lock />,
    items: [
      {
        to: routes.staffs.path,
        label: routes.staffs.title,
        section: routes.staffs.section,
      },
    ],
  },
  {
    title: 'Складской Учёт',
    icon: <PackageCheck />,
    items: [
      {
        to: routes.counterparties.path,
        label: routes.counterparties.title,
        section: routes.counterparties.section,
      },
      {
        to: routes.warehouses.path,
        label: routes.warehouses.title,
        section: routes.warehouses.section,
      },
    ],
  },
];
